<script setup lang="ts">
import { computed, ref } from "vue";

import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useTIWStore } from "@/stores/tiw/tiw";
import Button from "@/ui/button/button.vue";
import Checkbox from "@/ui/checkbox/checkbox.vue";
import ArrowIcon from "@/ui/icons/arrow.vue";

import Modal from "../../modal/modal.vue";

const TIWStore = useTIWStore();

const termsAndConditions = ref(false);
const processingPersonalData = ref(false);

const isAcceptedNext = computed(() => termsAndConditions.value && processingPersonalData.value);

function onStart() {
    TIWStore.switchStep("documentsUpload");
}

function onBack() {
    TIWStore.switchStep("confirmBelowPrice");
}
</script>

<template>
    <Modal class="tiw__step__personAuthentication">
        <div class="tiw__step__personAuthentication__body">
            <svg
                width="64"
                height="54"
                viewBox="0 0 64 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M38 1.5H26C14.687 1.5 9.029 1.5 5.516 5.016C2.003 8.532 2 14.187 2 25.5V28.5C2 39.813 2 45.471 5.516 48.984C9.032 52.497 14.687 52.5 26 52.5H38C49.313 52.5 54.971 52.5 58.484 48.984C61.997 45.468 62 39.813 62 28.5V25.5C62 14.187 62 8.529 58.484 5.016C54.968 1.503 49.313 1.5 38 1.5Z"
                    stroke="#808D9A"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M38 16.5H53M38 27H53M38 37.5H45.5"
                    stroke="#808D9A"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M11 39C14.108 31.257 25.688 30.75 29 39M25.25 20.25C25.25 21.6424 24.6969 22.9777 23.7123 23.9623C22.7277 24.9469 21.3924 25.5 20 25.5C18.6076 25.5 17.2723 24.9469 16.2877 23.9623C15.3031 22.9777 14.75 21.6424 14.75 20.25C14.75 18.8576 15.3031 17.5223 16.2877 16.5377C17.2723 15.5531 18.6076 15 20 15C21.3924 15 22.7277 15.5531 23.7123 16.5377C24.6969 17.5223 25.25 18.8576 25.25 20.25Z"
                    stroke="#6959CB"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
            <div class="tiw__step__personAuthentication__body__info">
                <p class="tiw__step__personAuthentication__body__info__title">
                    {{ useTranslate("tiw__personAuthentication__title") }}
                </p>
                <p class="tiw__step__personAuthentication__body__info__text">
                    {{ useTranslate("tiw__personAuthentication__text") }}
                </p>
            </div>
            <div class="tiw__step__personAuthentication__body__actions">
                <Checkbox v-model="termsAndConditions">
                    <span v-html="useTranslate('tiw__creditCardPreAuthorization__accepted')" />
                </Checkbox>
                <Checkbox v-model="processingPersonalData">
                    <span v-html="useTranslate('tiw__creditCardPreAuthorization__agree')" />
                </Checkbox>
                <div class="tiw__step__personAuthentication__body__actions__buttons">
                    <Button
                        type="button"
                        variant="skeleton"
                        class="tiw__step__chooseSigningType__btn-back"
                        @click="onBack"
                    >
                        <ArrowIcon />
                        <span>{{ useTranslate("tiw__back") }}</span>
                    </Button>
                    <Button :disabled="!isAcceptedNext" @click="onStart">
                        {{ useTranslate("tiw__start") }}
                    </Button>
                </div>
            </div>
        </div>
    </Modal>
</template>

<style lang="scss" src="./personAuthentication.scss"></style>
